import { Routes as ReactRoutes, Route, BrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import { GoogleAnalytics } from '@lair-finance/google'
import { DefaultLayout } from '@/app/layouts/DefaultLayout.tsx'
import { RestakeLayout } from '@/app/layouts/RestakeLayout.tsx'
import { AppLayout } from '@/app/layouts/AppLayout.tsx'
import { GameLayout } from '@/modules/game/app/layouts/GameLayout.tsx'
import { AuthorizedRoute } from '@/modules/game/app/layouts/AuthorizedRoute.tsx'
import { isProduction } from '@/shared/constants/env.ts'

const Main = lazy(() => import('@/routes/Main'))
const Stake = lazy(() => import('@/routes/Stake'))
const Unstake = lazy(() => import('@/routes/Unstake'))
const Claim = lazy(() => import('@/routes/Claim'))
const Restake = lazy(() => import('@/routes/Restake'))
const RestakeDetail = lazy(() => import('@/routes/Restake/Detail'))
const RestakeUnstake = lazy(() => import('@/routes/Restake/Unstake'))
const Earn = lazy(() => import('@/routes/Earn'))
const Airdrops = lazy(() => import('@/routes/Airdrops'))
const Lair = lazy(() => import('@/routes/Lair'))
const LairClaim = lazy(() => import('@/routes/Lair/claim'))
const Checker = lazy(() => import('@/routes/Checker'))
const Lr = lazy(() => import('@/routes/Lr'))
const LrClaim = lazy(() => import('@/routes/Lr/claim'))
const Error404 = lazy(() => import('@/routes/404.tsx'))
const MultiSender = lazy(() => import('@/routes/Tool/MultiSender.tsx'))
const AVS = lazy(() => import('@/routes/Tool/AVS.tsx'))
const Bridge = lazy(() => import('@/routes/Bridge'))

const GameConnect = lazy(() => import('@/modules/game/routes/Connect'))
const GameMain = lazy(() => import('@/modules/game/routes/Main'))

export default function Routes() {
  return (
    <BrowserRouter>
      <GoogleAnalytics gaId={'G-L0PWQ9L7ZK'} enabled={isProduction} />
      <ReactRoutes>
        <Route element={<AppLayout />}>
          <Route element={<DefaultLayout containerClassName={'max-w-[570px]'} />}>
            <Route index element={<Main />} />
            <Route path={'claim'} element={<Claim />} />
            <Route path={'tool'}>
              <Route path={'multi-sender'} element={<MultiSender />} />
              <Route path={'avs/:address/:roundIndex'} element={<AVS />} />
            </Route>
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[612px] px-4 sm:px-5'} contentClassName={'pt-4 sm:pt-[40px] pb-[80px]'} />}>
            <Route path={'stake'}>
              <Route index element={<Stake />} />
              <Route path={':tokenId'} element={<Stake />} />
            </Route>
            <Route path={'unstake'}>
              <Route index element={<Unstake />} />
              <Route path={':tokenId'} element={<Unstake />} />
            </Route>
            <Route path={'restake'}>
              <Route path={':tokenId'}>
                <Route index element={<RestakeDetail />} />
                <Route path={'unstake'} element={<RestakeUnstake />} />
              </Route>
            </Route>
          </Route>
          <Route element={<RestakeLayout containerClassName={'max-w-[1400px]'} />}>
            <Route path={'restake'} index element={<Restake />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[648px]'} />}>
            <Route path={'bridge'} element={<Bridge />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[762px]'} />}>
            <Route path={'checker'} element={<Checker />} />
            <Route path={'lr/:id'} element={<LrClaim />} />
            <Route path={'lair/:id'} element={<LairClaim />} />
          </Route>
          <Route element={<DefaultLayout containerClassName={'max-w-[1400px]'} />}>
            <Route path={'earn'} element={<Earn />} />
            <Route path={'airdrops'} element={<Airdrops />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'!p-0'} noContainer />}>
            <Route path={'lair'} element={<Lair />} />
            <Route path={'game/lair'} element={<Lair />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'!p-0'} noContainer noFooter />}>
            <Route path={'lr'} element={<Lr />} />
          </Route>
          <Route element={<DefaultLayout contentClassName={'sm:pt-20'} />}>
            <Route path={'*'} element={<Error404 />} />
          </Route>
        </Route>
        <Route path={'game'} element={<GameLayout />}>
          <Route index element={<GameConnect />} />
          <Route element={<AuthorizedRoute />}>
            <Route path={'main'} element={<GameMain />} />
          </Route>
        </Route>
      </ReactRoutes>
    </BrowserRouter>
  )
}
